module.exports = __webpack_public_path__ + "static/media/19ESCAP10.d53e7e35.jpg";